import Dexie from 'dexie';

const db = new Dexie('OLOrdemServico');

// Tabelas com {Local} não existem na nuvem, e são normalmente usadas apenas para reexibição.

db.version(6).stores({
    usuario: `
    ++id, 
    useidnuvem, 
    usenome, 
    usecpf, 
    usesenha, 
    usedataalteracao
    `,
  empresa: `
    ++id,
    empidnuvem,
    empdataalteracao,
    empidempresa,
    empnomeempresa,
    empnomefantasia,
    empcnpj
  `,
  parametro: `
    ++id, 
    paridvendedorlogado, 
    parvendedorcodigo,
    parvendedornome,
    parsenhaatual
    `,
  produto: `
    ++id,
    proidnuvem,
    proidcortamanhofinal,
    prodataalteracao,
    prodescricao,
    proidproduto,
    provalor,
    procodigointerno,
    proean,
    proidgrupo,
    proidcategoriaproduto,
    proreferencia,
    grudescricao
  `,
  grupo: `
    ++id,
    grudataalteracao,
    gruidnuvem,
    gruidgrupo,
    grudescricao
  `,
  categoria: `
    ++id,
    catdataalteracao,
    catidcategoria,
    catdescricao,
    catstatus,
    catservico
  `,
  cliente: `
    ++id,
    cliidnuvem,
    clidataalteracao,
    cliidcliente,
    clinome,
    clicpf,
    clinomefantasia
  `,
  ordemservico: `
    ++id,
    orsidnuvem,
    orsdatanuvem,
    orsdataalteracao,
    orsidordemservico,
    orsidlocal,
    orsidempresa,
    orsobservacao,
    orsidcliente,
    orsdatacadastro,
    orsidusuariorecebeu,
    orsdatafechamento,
    orsstatus,
    orsidvendedor,
    orsidusuariocadastro,
    orsexclusao,
    orsdatarobo,
    orsnroexterno
  `,
  ordemservicoitem: `
    ++id,
    osiidnuvem,
    osidatanuvem,
    osidataalteracao,
    osiidordemservicoitem,
    osiidproduto,
    osicodigoproduto,
    osipreco,
    osidatainclusao,
    osiobservacao,
    osiquantidade,
    osiidusuario,
    osiidordemserviconuvem,
    osiidordemservicolocal,
    osiexclusao
  `,
  vendedor:`
    ++id,
    venidnuvem,
    vennome,
    vencpf,
    vencodigo,
    vendataalteracao
  `,
  fornecedor:`
    ++id,
    foridnuvem,
    fornome,
    fortelefone,
    forfantasia,
    fortipopessoa,
    forendereco,
    forcnpj_cpf,
    fortipo,
    fordataalteracao
  `,
    prestacaoservico:`
    ++id,
    prsidnuvem,
    prsidprestacaoservico,
    prsnumeroos,
    prsidempresa,
    prsidcliente,
    prsnomecliente,
    prsdatatransmissao,
    prsidlocal,
    prstipo,
    prstotal,
    prstotalservico,
    prstotalproduto,
    prsidusuario,
    prsidfornecedor,
    prsidvendedor,
    prsrecebidopor,
    prsidtecnicoverificacao,
    prsdatainclusao,
    prsobservacao,
    prslinkpedidoitem,
    prsidvendedoralteracao,
    prsidveiculo,
    prsdataalteracao
  `,
  prestacaoservicoitem:`
    ++id,
    priidnuvem,
    prinumeroos,
    priidprestacaoservicoitem,
    priidprestacaoservico,
    priidprestacaoservicolocal,
    priidproduto,
    pridescricao,
    priordem,
    priidusuario,
    priquantidade,
    priidgrupo,
    privalor,
    pritotal,
    pridatainclusao,
    pritecnico,
    pritecnico2,
    pritecnico3,
    pritecnicoretiroupeca,
    priobservacao,
    priordemitem,
    prilinkpedidoitem,
    pridataalteracao
  `,
  imagem: `
    ++id,
    relacao,
    relacaoidlocal,
    blob,
    datacriacao,
    nomearquivo,
    rotaapi,
    tentativa,
    datanuvem
  `,
  veiculo: `
    ++id,
    veiidnuvem,
    veidataalteracao,
    veiidveiculo,
    veidescricao,
    veiplaca,
    veiidcliente,
    veiidcor,
    veiidmarca
  `,
  cor: `
    ++id,
    coridnuvem,
    cordataalteracao,
    coridcor,
    cordescricao
  `,
  marcaveiculo: `
    ++id,
    mavidnuvem,
    mavdataalteracao,
    mavidmarcaveiculo,
    mavdescricao
  `,
});

db.open().then(function (db) {
  console.log('db | aberto: ', db);
}).catch (function (err) {
  console.log('db | erro: ', err)
});

// ORDERPRODUCAO?


export default db;


/* 
OP
DATA
LOTE
TURNO
DESCRICAO - LOTE
GRANULOMETRIA
INICIO PROD
QUANTIDADE
EMBALAGEM
EMBLALAGEM
DESCRICAO - LOTE EMBALAGEM
QUANTIDADE EMBALAGEM
LOCAL ARMAZENAMENTO
DESCRICAO LOCAL
TERMINO PROD
*/